import { apiDomain as api, apiKey } from '../appConfig';

const passwordLogin = async (credentials) => {
	const response = await fetch(`${api}/service/SRTAPP/api/SRTAPP/SRTAPP002_S01`, {
		method: 'POST',
		body: JSON.stringify(credentials),
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': apiKey,
		},
	});

	if (!response.ok) {
		throw new Error(`Password login failed with status ${response.status}`);
	}

	return response.json();
};

export default passwordLogin;



// WEBPACK FOOTER //
// ./src/js/fetch/passwordLogin.js